import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SurveyTemplateService {

  static getSurveyTemplateByIdCorso = (idCorso) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/survey-template/findByIdCorso`;
      ApiService.postRequest(resolve, reject, url, idCorso);
    });
  };

  static getSurveyTemplateByIdArea = (idArea) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/survey-template/findByIdArea`;
      ApiService.postRequest(resolve, reject, url, idArea);
    });
  };

  static getSurveyTemplateByIdContenuto = (idContenuto) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/survey-template/findByIdContenuto`;
      ApiService.postRequest(resolve, reject, url, idContenuto);
    });
  };

  static createSurveyTemplate = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/survey-template/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static deleteSurveyTemplate = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/survey-template/delete`;  
      ApiService.delete(resolve, reject, url, id);
    });
  };

  static updateSurveyTemplate = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/survey-template/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };
}

